import { render, staticRenderFns } from "./tubeprofileselection.vue?vue&type=template&id=d16ff39c&"
import script from "./../../ts/articleattributes/tubeprofileselection.ts?vue&type=script&lang=js&"
export * from "./../../ts/articleattributes/tubeprofileselection.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports